import { useState, useEffect } from "react"
import { X } from "lucide-react"
import { motion, AnimatePresence } from "framer-motion"
import { suppliers, models } from "../../data/mock"
import { createPhones } from "../../api/products/post"

type Props = {
    currentStore: any
    isOpen: boolean
    onClose: () => void
    onAdd: (phone: any) => void
    existingImeis: string[]
    suppliers: any
    models: any
}

export default function AddPhoneModal({
    currentStore,
    isOpen,
    onClose,
    onAdd,
    existingImeis,
    suppliers,
    models,
}: Props) {
    const [modelId, setModelId] = useState("")
    const [imei, setImei] = useState("")
    const [supplier, setSupplier] = useState("")
    const [buyPrice, setBuyPrice] = useState("")
    const [error, setError] = useState("")
    const [supplierId, setSupplierId] = useState("")
    const [loading, setLoading] = useState(false)
     
    // Pré-remplir le prix quand le modèle change
    //   useEffect(() => {
    //     const selectedModel = models.find(m => m.id === modelId)
    //     if (selectedModel?.defaultBuyPrice) {
    //       setBuyPrice(String(selectedModel.defaultBuyPrice))
    //     }
    //   }, [modelId])

    //   const handleSubmit = () => {
    //     if (!modelId || !imei || !buyPrice || !supplier) {
    //       setError("Veuillez remplir tous les champs obligatoires")
    //       return
    //     }

    //     if (existingImeis.includes(imei)) {
    //       setError("Ce numéro IMEI existe déjà")
    //       return
    //     }

    //     const model = models.find(m => m.id === modelId)

    //     onAdd({
    //       id: Date.now().toString(),
    //       type: "PHONE",
    //       modelId,
    //       name: model?.name, // temporaire pour compatibilité
    //       identifier: imei,
    //       supplier,
    //       buyPrice: Number(buyPrice),
    //       status: "IN_STOCK",
    //       createdAt: new Date().toISOString(),
    //     })

    //     // Reset
    //     setModelId("")
    //     setImei("")
    //     setSupplier("")
    //     setBuyPrice("")
    //     setError("")
    //     onClose()
    //   }

    useEffect(() => {
        const m = models?.find((m: any) => m._id === modelId)
        if (m?.defaultBuyPrice) {
            setBuyPrice(String(m.defaultBuyPrice))
        }
    }, [modelId])

    const submit = async () => {
        setError("")

        if (!modelId || !imei || !supplierId || !buyPrice) {
            setError("Champs obligatoires manquants")
            return
        }

        if (existingImeis.includes(imei)) {
            setError("IMEI déjà existant")
            return
        }

        try {
            setLoading(true)
            const res = await createPhones({
                modelId,
                imei,
                supplierId,
                buyPrice: Number(buyPrice),
                storeId: currentStore?._id
            })

            onAdd(res.data)
            onClose()
            setModelId("")
            setImei("")
            setSupplierId("")
            setBuyPrice("")
        } catch (e: any) {
            setError(e.response?.data?.message || "Erreur serveur")
        } finally {
            setLoading(false)
        }
    }

    return (
        <AnimatePresence>
            {isOpen && (
                <motion.div
                    className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                >
                    <motion.div
                        className="bg-white rounded-2xl shadow-xl w-full max-w-md p-6 space-y-6"
                        initial={{ scale: 0.9, y: 40 }}
                        animate={{ scale: 1, y: 0 }}
                        exit={{ scale: 0.9, y: 40 }}
                        transition={{ duration: 0.25 }}
                    >
                        {/* Header */}
                        <div className="flex justify-between items-center">
                            <h2 className="text-lg font-semibold text-gray-800">
                                Ajouter un téléphone
                            </h2>
                            <button
                                onClick={onClose}
                                className="p-1 rounded hover:bg-gray-100"
                            >
                                <X />
                            </button>
                        </div>

                        {/* Error */}
                        {error && (
                            <div className="bg-red-50 text-red-600 text-sm p-2 rounded-lg">
                                {error}
                            </div>
                        )}

                        {/* Form */}
                        <div className="space-y-4">

                            {/* Modèle */}
                            <div>
                                <label className="text-sm text-gray-600">
                                    Modèle *
                                </label>
                                <select
                                    value={modelId}
                                    onChange={(e) => setModelId(e.target.value)}
                                    // value={modelId}
                                    // onChange={(e) => setModelId(e.target.value)}
                                    className="w-full border rounded-xl px-3 py-2 focus:ring-2 focus:ring-blue-500"
                                >
                                    <option value="">Sélectionner un modèle</option>
                                    {models && models?.map((m: any) => (
                                        <option key={m._id} value={m._id}>{m.name}</option>
                                    ))}
                                </select>
                            </div>

                            {/* IMEI */}
                            <div>
                                <label className="text-sm text-gray-600">
                                    IMEI *
                                </label>
                                <input
                                    value={imei}
                                    onChange={(e) => setImei(e.target.value)}
                                    placeholder="15 chiffres"
                                    className="w-full border rounded-xl px-3 py-2 focus:ring-2 focus:ring-blue-500"
                                />
                            </div>

                            {/* Fournisseur */}
                            <div>
                                <label className="text-sm text-gray-600">
                                    Fournisseur *
                                </label>
                                <select
                                    value={supplierId}
                                    onChange={(e) => setSupplierId(e.target.value)}
                                    // value={supplier}
                                    // onChange={(e) => setSupplier(e.target.value)}
                                    className="w-full border rounded-xl px-3 py-2 focus:ring-2 focus:ring-blue-500"
                                >
                                    <option value="">Sélectionner un fournisseur</option>
                                    {suppliers && suppliers?.map((s: any) => (
                                        <option key={s._id} value={s._id}>
                                            {s?.name}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            {/* Prix achat */}
                            <div>
                                <label className="text-sm text-gray-600">
                                    Prix d’achat (FCFA) *
                                </label>
                                <input
                                    type="number"
                                    value={buyPrice}
                                    onChange={(e) => setBuyPrice(e.target.value)}
                                    className="w-full border rounded-xl px-3 py-2 focus:ring-2 focus:ring-blue-500"
                                />
                                <p className="text-xs text-gray-400 mt-1">
                                    Prix par défaut du modèle (modifiable)
                                </p>
                            </div>
                        </div>

                        {/* Actions */}
                        <div className="flex justify-end gap-3 pt-2">
                            <button
                                onClick={onClose}
                                className="px-4 py-2 rounded-xl border hover:bg-gray-50"
                            >
                                Annuler
                            </button>
                            <button
                                // onClick={handleSubmit}
                                onClick={submit}
                                disabled={loading}
                                className="px-4 py-2 rounded-xl bg-blue-600 text-white hover:bg-blue-700"
                            >
                                {loading ? "Ajout..." : "Enregistrer"}
                            </button>
                        </div>
                    </motion.div>
                </motion.div>
            )}
        </AnimatePresence>
    )
}
